import type { TransferHeaderProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/CallsTab/CallsTransferStatus/TransferHeader/index.types';
import { TONE } from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React from 'react';
import { cn } from '~/lib/utils';

/** The card's title bar: what is happening, and how far along it is. */
export const TransferHeader: React.FC<TransferHeaderProps> = ({
  isWarm,
  state,
}) => (
  <div className={cn('flex items-center gap-2', TONE.warn.header)}>
    <span className="text-[10px] font-bold uppercase tracking-[0.08em] text-amber-400">
      {isWarm ? 'Warm transfer in flight' : 'Transfer view open'}
    </span>
    <div className="flex-1" />
    <span className="font-sp-mono text-[10px] text-amber-400">{state}</span>
  </div>
);
